const tabs = document.querySelectorAll('.js-series-collection__tab');

// Add initial state setup
function initializeTabs() {
  tabs.forEach((tab, index) => {
    // Set ARIA attributes and tabindex for all tabs
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
    tab.tabIndex = index === 0 ? 0 : -1;

    // Get the panel ID from the href attribute
    const panelId = tab.getAttribute('href').substring(1);
    const panel = document.getElementById(panelId);

    if (panel) {
      // Set up panel attributes
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      panel.classList.add('js-series-collection__tab-panel');

      // Set initial visibility
      if (index === 0) {
        panel.classList.add('is-active');
      } else {
        panel.classList.remove('is-active');
        panel.hidden = true;
      }
    }

    // Set first tab as active
    if (index === 0) {
      tab.classList.add('is-active');
    }
  });
}

function tabSwitch() {
  let tabsArray = Array.prototype.slice.call(tabs);
  let index = tabsArray.indexOf(this);

  const resetTab = function () {
    document.querySelector('.js-series-collection__tab.is-active').classList.remove('is-active');
    document
      .querySelector('.js-series-collection__tab[aria-selected=true]')
      .removeAttribute('aria-selected');
    document.querySelectorAll('.js-series-collection__tab').forEach((elm) => {
      elm.tabIndex = -1;
    });
    document.querySelector('.js-series-collection__tab-panel.is-active').classList.remove('is-active');
    document.querySelectorAll('.js-series-collection__tab-panel').forEach(panel => {
      panel.hidden = true;
    });
  };

  const setTab = function (tab, tabpanel) {
    tab.classList.add('is-active');
    tab.tabIndex = 0;
    tab.setAttribute('aria-selected', true);
    tabpanel.classList.add('is-active');
    tabpanel.hidden = false;
  };

  if (event.type === 'keyup') {
    if (event.key === 'ArrowRight') {
      if (tabsArray[index + 1]) {
        tabsArray[index + 1].focus();
        resetTab();
        setTab(
          tabsArray[index + 1],
          document.querySelectorAll('.js-series-collection__tab-panel')[index + 1]
        );
      } else {
        tabsArray[0].focus();
        resetTab();
        setTab(tabsArray[0], document.querySelectorAll('.js-series-collection__tab-panel')[0]);
      }
    }
    if (event.key === 'ArrowLeft') {
      if (tabsArray[index - 1]) {
        tabsArray[index - 1].focus();
        resetTab();
        setTab(
          tabsArray[index - 1],
          document.querySelectorAll('.js-series-collection__tab-panel')[index - 1]
        );
      } else {
        let lastTab = tabsArray[tabsArray.length - 1];
        lastTab.focus();
        resetTab();
        setTab(
          lastTab,
          document.querySelectorAll('.js-series-collection__tab-panel')[tabsArray.length - 1]
        );
      }
    }
  }
  if (event.type === 'click') {
    resetTab();
    setTab(this, document.querySelectorAll('.js-series-collection__tab-panel')[index]);
  }
}

tabs.forEach((tab) => {
  tab.addEventListener('click', tabSwitch);
  tab.addEventListener('keyup', tabSwitch);
});

// Initialize tabs when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeTabs);
